import React, {useEffect} from 'react'
import Aos from "aos"
import "aos/dist/aos.css"
import "../CSS/Skill.css";
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import StarHalfIcon from '@material-ui/icons/StarHalf';
import css from '../Image/css.png';
import js from '../Image/js.jpg';
import html from '../Image/html5.png';
import cpp from '../Image/cpp.png';
import mysql from '../Image/mysql.png';
import react from '../Image/react.jpg';
import github from '../Image/github.png';
import java from '../Image/java.png';
import database from '../Image/database.jpg'
import c from '../Image/c.png';

const Skill = () => {

  useEffect(() => {
    Aos.init({duration:2000});
 }, []);
    return (
    <>
        
        <div className="backSkill">
            <div data-aos="fade-down" className="headerSkill">
                <h1> My Skills</h1>
            </div>
            <div className='containerSkill'>
                  <section className="section">
                    <div className="wall">
                      <div className="v-boxes">
                        <div className="box">
                          <div className="box-face">
                            <div className="box-text">
                              <img src= {cpp} alt="Cpp..."/>
                            </div>
                          </div>
                          <div className="box-back">
                            <div className="box-text">
                              <StarIcon style={{ fontSize: 15 }}/>
                              <StarIcon style={{ fontSize: 15 }}/>
                              <StarIcon style={{ fontSize: 15 }}/>
                              <StarIcon style={{ fontSize: 15 }}/>
                              <StarHalfIcon style={{ fontSize: 15 }}/>
                            </div>
                          </div>
                        </div>
                        <div className="box">
                          <div className="box-face">
                            <div className="box-text">
                              <img src= {java} alt="java..."/>
                            </div>
                          </div>
                          <div className="box-back">
                            <div className="box-text">
                              <StarIcon style={{ fontSize: 15 }}/>
                              <StarIcon style={{ fontSize: 15 }}/>
                              <StarIcon style={{ fontSize: 15 }}/>
                              <StarBorderIcon style={{ fontSize: 15 }}/>
                              <StarBorderIcon style={{ fontSize: 15 }}/>
                            </div>
                          </div>        
                        </div>
                        <div className="box">
                          <div className="box-face">
                            <div className="box-text">
                              <img src= {js} alt="JavaScript..."/>
                            </div>
                          </div>
                        <div className="box-back">
                          <div className="box-text">
                            <StarIcon style={{ fontSize: 15 }}/>
                            <StarIcon style={{ fontSize: 15 }}/>
                            <StarIcon style={{ fontSize: 15 }}/>
                            <StarIcon style={{ fontSize: 15 }}/>
                            <StarBorderIcon style={{ fontSize: 15 }}/>
                          </div>
                        </div>
                      </div>
                    <div className="box">
                      <div className="box-face">
                        <div className="box-text">
                          <img src= {c} alt="C..."/>
                        </div>
                      </div>
                      <div className="box-back">
                        <div className="box-text">
                          <StarIcon style={{ fontSize: 15 }}/>
                          <StarIcon style={{ fontSize: 15 }}/>
                          <StarIcon style={{ fontSize: 15 }}/>
                          <StarIcon style={{ fontSize: 15 }}/>
                          <StarBorderIcon style={{ fontSize: 15 }}/>
                        </div>
                      </div>
                    </div>
                  </div>
                <div className="v-boxes second">
                  <div className="box">
                    <div className="box-face">
                      <div className="box-text">
                        <img src= {mysql} alt=""/>
                      </div>
                    </div>
                    <div className="box-back">
                      <div className="box-text">
                        <StarIcon style={{ fontSize: 15 }}/>
                       <StarIcon style={{ fontSize: 15 }}/>
                        <StarIcon style={{ fontSize: 15 }}/>
                        <StarBorderIcon style={{ fontSize: 15 }}/>
                        <StarBorderIcon style={{ fontSize: 15 }}/>
                      </div>
                    </div>
                  </div>
                  <div className="box">
                    <div className="box-face">
                      <div className="box-text">
                      <img src= {react} alt="React..."/>
                    </div>
                  </div>
                  <div className="box-back">
                    <div className="box-text">
                      <StarIcon style={{ fontSize: 15 }}/>
                      <StarIcon style={{ fontSize: 15 }}/>
                      <StarIcon style={{ fontSize: 15 }}/>
                      <StarBorderIcon style={{ fontSize: 15 }}/>
                      <StarBorderIcon style={{ fontSize: 15 }}/>
                    </div>
                  </div>
                </div>
                <div className="box">
                  <div className="box-face">
                    <div className="box-text">
                    <img src= {css} alt="css..."/>
                  </div>
                </div>
                <div className="box-back">
                  <div className="box-text">
                    <StarIcon style={{ fontSize: 15 }}/>
                    <StarIcon style={{ fontSize: 15 }}/>
                    <StarIcon style={{ fontSize: 15 }}/>
                    <StarHalfIcon style={{ fontSize: 15 }}/>
                    <StarBorderIcon style={{ fontSize: 15 }}/>
                  </div>
                </div>
              </div>
           </div>
          <div className="v-boxes third">
            <div className="box">
              <div className="box-face">
                <div className="box-text">
                  <img src={database} alt="Database..."/>
                </div>
              </div>
              <div className="box-back">
                <div className="box-text">
                  <StarIcon style={{ fontSize: 15 }}/>
                  <StarIcon style={{ fontSize: 15 }}/>
                  <StarIcon style={{ fontSize: 15 }}/>
                  <StarBorderIcon style={{ fontSize: 15 }}/>
                  <StarBorderIcon style={{ fontSize: 15 }}/>
                </div>
              </div>
            </div>
            <div className="box">
              <div className="box-face">
              <div className="box-text">
                <img src= {html} alt="HTML..."/>
              </div>
            </div>
            <div className="box-back">
              <div className="box-text">
                <StarIcon style={{ fontSize: 15 }}/>
                <StarIcon style={{ fontSize: 15 }}/>
                <StarIcon style={{ fontSize: 15 }}/>
                <StarIcon style={{ fontSize: 15 }}/>
                <StarBorderIcon style={{ fontSize: 15 }}/>
              </div>
            </div>
          </div>
        </div>
        <div className="v-boxes forth">
          <div className="box link">
            <div className="box-face">
              <div className="box-text">
                <img src= {github} alt="Github..."/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
    </div>
    </>
    )
}

export default Skill

